'use client';

import { useRef, useEffect } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { useGaContext } from '@/context/GoogleAnalyticsContext';

interface ListWrapperProps extends PropsWithChildren {
	elementId: string;
	title: string;
}

export const ListTrackingWrapper: FC<ListWrapperProps> = ({
	children,
	elementId,
	title,
}) => {
	const { sendGaEvent } = useGaContext('StructuredListItem');
	const titleRef = useRef<string>(title);
	const elementIdRef = useRef<string>(elementId);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						sendGaEvent('structured_list_item_view', {
							nonInteraction: true,
							placement: titleRef.current,
						});
						observer.disconnect();
					}
				});
			},
			{ threshold: 0.3 },
		);

		const listElement = document.getElementById(elementIdRef.current);
		if (listElement) {
			observer.observe(listElement);
		}

		return () => {
			observer.disconnect();
		};
	}, [sendGaEvent]);

	return children;
};
